module.exports = __webpack_public_path__ + "img/backspace-reverse.a46f22ed.svg";